<template>
  <el-config-provider :locale="locale">
    <router-view></router-view>
    <PWABadge />
  </el-config-provider>
</template>

<script setup lang="ts">
  import { ElConfigProvider } from 'element-plus'
  // import { ref, watch, onMounted, onUnmounted } from 'vue'
  // import { useI18n } from 'vue-i18n'
  import zhCn from 'element-plus/es/locale/lang/zh-cn'
  import en from 'element-plus/es/locale/lang/en'
  import { useAuthStore } from '@/stores/auth'
  import PWABadge from './components/PWABadge.vue'
  const { locale: i18nLocale } = useI18n()
  const locale = ref(i18nLocale.value === 'zh' ? zhCn : en)
  const authStore = useAuthStore()

  // Watch for language changes
  watch(
    () => i18nLocale.value,
    newLang => {
      locale.value = newLang === 'zh' ? zhCn : en
    }
  )

  // 监听认证状态变化
  watch(
    () => authStore.isAuthenticated,
    isAuthenticated => {
      if (isAuthenticated && !authStore.isTokenExpired) {
        console.log('Auth state changed, starting refresh timer')
        authStore.startRefreshTokenTimer()
      }
    }
  )

  // 处理页面刷新的场景
  onMounted(() => {
    // if (authStore.isAuthenticated && !authStore.isTokenExpired) {
    //   console.log('App mounted with valid auth, starting refresh timer')
    //   authStore.startRefreshTokenTimer()
    // }
    // checkAuth()
  })

  onUnmounted(() => {
    // authStore.stopRefreshTokenTimer()
  })
  const route = useRoute()
  const router = useRouter()
  // function checkAuth() {
  //   // 如果不是登录页，检查登录状态
  //   if (route.path !== '/login') {
  //     if (!checkAuthStatus()) {
  //       router.push({
  //         path: '/login',
  //         replace: true,
  //         query: {
  //           redirect: route.fullPath,
  //         },
  //       })
  //     }
  //   }
  // }
</script>

<style scoped>
  /* 移除了背景相关样式 */
</style>
